import React from 'react';
import { toPng } from 'html-to-image';
import { MetaData } from 'models/MetaData/metaData.model';

export const downloadProductMap = (
  ref: React.RefObject<HTMLDivElement>,
  key: string,
  fileName: string
): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!ref?.current) {
      reject(new Error('No reference to the container'));
      return;
    }
    toPng(ref.current, { cacheBust: true, backgroundColor: 'white' })
      .then((dataUrl: string) => {
        const link = document.createElement('a');
        link.download = `${fileName}.${key}`;
        link.href = dataUrl;
        link.click();
        resolve();
      })
      .catch(error => reject(error));
  });
};
